import { buildHomeStructuredData } from './structuredData';

/**
 * Injects the home page Schema.org JSON-LD.
 * Kept separate from the runtime Open Graph / Twitter tag manager.
 */
export default function SchemaJsonLd() {
  const data = buildHomeStructuredData();
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}